import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

const ConfirmationDialog = ({ isVisible, message, onConfirm, onCancel }) => {
  return (
    <Dialog header="Confirm" visible={isVisible} style={{ width: '50vw' }} closable={false} modal onHide={onCancel}>
      <p>{message}</p>
      <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem' }}>
        <Button label="Yes" style={{ backgroundColor: 'rgb(12, 146, 205)' }} onClick={onConfirm} />
        <Button label="No" style={{ backgroundColor: 'rgb(255, 0, 0)' }} onClick={onCancel} />
      </div>
    </Dialog>
  );
};

export default ConfirmationDialog;



// WEBPACK FOOTER //
// ./src/components/Tutorial/exitTutorialDialog.js